import InputField from '@/features/ui/inputs/components/InputField'
import { InputFieldRef } from '@/features/ui/inputs/components/InputField/types'
import Typography from '@/features/ui/typography'
import { FC, useRef } from 'react'
import { KeyboardTypeOptions, StyleSheet, View } from 'react-native'

interface LabeledInputFieldProps {
    value: string
    onChange: (value: string) => void
    label: string
    keyboardType?: KeyboardTypeOptions
}

const LabeledInputField: FC<LabeledInputFieldProps> = ({
    value,
    onChange,
    label,
    keyboardType,
}) => {
    const inputRef = useRef<InputFieldRef>(null)

    const handleLabelPress = () => {
        inputRef.current?.focus()
    }

    return (
        <View style={styles.container}>
            <Typography.Heading variant="h5" onPress={handleLabelPress}>
                {label}
            </Typography.Heading>
            <InputField
                ref={inputRef}
                value={value}
                placeholder=""
                onChange={onChange}
                keyboardType={keyboardType}
                style={styles.inputField}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 8,
    },
    inputField: {
        width: '100%',
    },
})

export default LabeledInputField
